import { CAMPAIGN_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'completedTransfers',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Completed Transfers',
  },
}

const keys = {
  statKey: 'transfer_complete',
  componentKeys: [CAMPAIGN_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const completedTransfers = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { completedTransfers }
